import { createReducer, on, ActionReducerMap } from '@ngrx/store';
import * as ColorPaletteActions from './color-palette.actions';
import { OrgTypes } from '@mode/shared/contract-common';
import { ReadonlyCollection } from '@mode/shared/contract-common';

export const colorPaletteFeatureKey = 'colorPalette';

export interface State {
  isLoading: boolean;
  isComplete: boolean;
  error: Error | null;
  colorPalettes: ReadonlyCollection<OrgTypes.ColorPalette> | undefined;
}

export const initialState: State = {
  isLoading: false,
  isComplete: false,
  error: null,
  colorPalettes: undefined,
};

export const isCompleteReducer = createReducer(
  initialState.isComplete,
  on(ColorPaletteActions.loadColorPalettes, (state) => false),
  on(ColorPaletteActions.loadColorPalettesSuccess, (state) => true),
  on(ColorPaletteActions.loadColorPalettesFailure, (state) => true)
);

export const isLoadingReducer = createReducer(
  initialState.isLoading,
  on(ColorPaletteActions.loadColorPalettes, (state) => true),
  on(ColorPaletteActions.loadColorPalettesSuccess, (state) => false),
  on(ColorPaletteActions.loadColorPalettesFailure, (state) => false)
);

export const errorReducer = createReducer(
  initialState.error,
  on(ColorPaletteActions.loadColorPalettes, (state) => null),
  on(ColorPaletteActions.loadColorPalettesFailure, (state, action) => action.error)
);

export const colorPalettesReducer = createReducer(
  initialState.colorPalettes,
  on(ColorPaletteActions.loadColorPalettesSuccess, (state, action) => action.palettes),
  on(ColorPaletteActions.loadColorPalettesFailure, (state, action) => undefined)
);

export const reducer: ActionReducerMap<State> = {
  colorPalettes: colorPalettesReducer,
  error: errorReducer,
  isComplete: isCompleteReducer,
  isLoading: isLoadingReducer,
};
